/**
 * Builds request headers for a GraphQL query towards DatoCMS Content Delivery
 * API.
 *
 * @return {HeadersInit} The built request headers
 */
export function buildRequestHeaders(
/** The options to build the request headers from */
options) {
    var headers = {
        Accept: 'application/json',
        // API token for the project
        Authorization: "Bearer ".concat(options.token),
    };
    if (options.includeDrafts) {
        headers['X-Include-Drafts'] = 'true';
    }
    if (options.excludeInvalid) {
        headers['X-Exclude-Invalid'] = 'true';
    }
    if (options.environment) {
        headers['X-Environment'] = options.environment;
    }
    if (options.returnCacheTags) {
        headers['X-Cache-Tags'] = 'true';
    }
    if (options.contentLink) {
        headers['X-Visual-Editing'] = options.contentLink;
    }
    if (options.baseEditingUrl) {
        headers['X-Base-Editing-Url'] = options.baseEditingUrl;
    }
    return headers;
}
//# sourceMappingURL=buildRequestHeaders.js.map